import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { HIDE_FLASH_BANNER } from '@consts/index'
import { useRouter } from 'next/router'

import styles from './styles.module.scss'
import { RootState } from '@store/redux/reducers'
import { NotificationBannerState } from '@store/redux/reducers/otherReducers'
import PromoBanner from './PromoBanner'
import AppContext from '@components/AppContext'
import PushNotificationBanner from './PushNotificationBanner'
import { useCampaignBanner } from '@helpers/hooks/useCampaignBanner'
import useIsReactClient from '@helpers/hooks/useIsReactClient'

const FlashBanner = () => {
  const router = useRouter()
  const { flashBanner } = useContext(AppContext)
  const { showBanner, ...banner } = flashBanner || {}
  const isReactClient = useIsReactClient()

  const { campaignBanner, campaignSlug } = useCampaignBanner()

  const notificationBanner = useSelector<RootState, NotificationBannerState>(
    state => state.notificationBanner
  )

  // When a campaign slug is active, only show the campaign banner if Contentful
  // returned a matching entry. Never fall back to the standard banner.
  const showCampaignBanner = !!campaignSlug && !!campaignBanner && isReactClient

  const showStandardBanner =
    !campaignSlug &&
    Object.keys(banner).length > 0 &&
    showBanner &&
    !HIDE_FLASH_BANNER.includes(router.query.pagesHandle?.toString?.() ?? '')

  return (
    <>
      <PushNotificationBanner {...notificationBanner} />
      {showCampaignBanner && (
        <section data-testid="DynamicFlashBanner" className={styles.flash}>
          <PromoBanner {...campaignBanner} />
        </section>
      )}
      {showStandardBanner && (
        <section data-testid="DynamicFlashBanner" className={styles.flash}>
          <PromoBanner {...banner} />
        </section>
      )}
    </>
  )
}

export default FlashBanner
